import React, { useState, useEffect } from 'react';
import { Container, Typography, Box, Paper, Grid, Button, Card, CardContent, CardActions, CardMedia, CircularProgress, Alert } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import FacebookIcon from '@mui/icons-material/Facebook';
import GoogleIcon from '@mui/icons-material/Google';

const NewIntegration = () => {
  const [client, setClient] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { clientId } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchClient = async () => {
      try {
        const token = localStorage.getItem('token');
        
        const response = await axios.get(`/api/clients/${clientId}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        
        if (response.data.status === 'success') {
          setClient(response.data.data.client);
        }
        
        setLoading(false);
      } catch (error) {
        console.error('Error fetching client:', error);
        setError('Erro ao carregar dados do cliente. Por favor, tente novamente.');
        setLoading(false);
        
        if (error.response && error.response.status === 401) {
          navigate('/login');
        }
      }
    };
    
    fetchClient();
  }, [clientId, navigate]);

  const handleMetaIntegration = async () => {
    try {
      const token = localStorage.getItem('token');
      
      const response = await axios.get(`/api/clients/${clientId}/meta/auth-url`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      if (response.data.status === 'success') {
        // Redirecionar para a URL de autorização do Facebook
        window.location.href = response.data.data.authUrl;
      }
    } catch (error) {
      console.error('Error getting Meta auth URL:', error);
      setError('Erro ao iniciar integração com Meta. Por favor, tente novamente.');
    }
  };

  const handleGoogleIntegration = async () => {
    try {
      setError(null);
      console.log("Iniciando processo de integração com Google...");
      
      // Usar a mesma abordagem do Meta, evitando chamada direta
      const token = localStorage.getItem('token');
      window.location.href = `/api/clients/${clientId}/google/auth`;
      
    } catch (error) {
      console.error('Erro ao iniciar integração com Google:', error);
      setError('Erro ao iniciar integração com Google. Por favor, tente novamente.');
    }
  };


  if (loading) {
    return (
      <Container sx={{ display: 'flex', justifyContent: 'center', mt: 5 }}>
        <CircularProgress />
      </Container>
    );
  }

  if (!client) {
    return (
      <Container>
        <Alert severity="error">Cliente não encontrado</Alert>
      </Container>
    );
  }

  return (
    <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4">Nova Integração</Typography>
        <Typography variant="subtitle1">
          Cliente: {client.name}
        </Typography>
      </Box>
      
      {error && (
        <Alert severity="error" sx={{ mb: 3 }}>
          {error}
        </Alert>
      )}
      
      <Typography variant="h6" sx={{ mb: 2 }}>
        Selecione a plataforma para integração:
      </Typography>
      
      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Card>
            <CardMedia
              component="div"
              sx={{ 
                height: 140, 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                bgcolor: '#4267B2',
                color: 'white'
              }}
            >
              <FacebookIcon sx={{ fontSize: 80 }} />
            </CardMedia>
            <CardContent>
              <Typography gutterBottom variant="h5" component="div">
                Meta Ads
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Conecte-se com o Facebook e Instagram Ads para monitorar campanhas, análise de performance e otimização.
              </Typography>
            </CardContent>
            <CardActions>
              <Button 
                size="large" 
                fullWidth 
                variant="contained"
                onClick={handleMetaIntegration}
              >
                Conectar Meta Ads
              </Button>
            </CardActions>
          </Card>
        </Grid>
        
        <Grid item xs={12} md={6}>
          <Card>
            <CardMedia
              component="div"
              sx={{ 
                height: 140, 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                bgcolor: '#4285F4',
                color: 'white'
              }}
            >
              <GoogleIcon sx={{ fontSize: 80 }} />
            </CardMedia>
            <CardContent>
              <Typography gutterBottom variant="h5" component="div">
                Google Analytics
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Integre o Google Analytics 4 para acompanhar conversões, engajamento e comportamento dos usuários.
              </Typography>
            </CardContent>
            <CardActions>
              <Button 
                size="large" 
                fullWidth 
                variant="contained"
                onClick={handleGoogleIntegration}
              >
                Conectar Google Analytics
              </Button>
            </CardActions>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};

export default NewIntegration;
